import { render, staticRenderFns } from "./reportPostModal.vue?vue&type=template&id=26793549&"
import script from "./reportPostModal.vue?vue&type=script&lang=js&"
export * from "./reportPostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports